import { EtlJob, EtlJobsClient, ImportModelEtlJobsRequest } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const etlJobsClient = new EtlJobsClient(undefined, axios);

export const useEtlJobs = (importModelEtlJobsRequest: ImportModelEtlJobsRequest | undefined, options?: any) => {
  return useQuery<EtlJob[] | null>({
    ...options,
    queryKey: ["etlJobs"],
    initialData: null,
    queryFn: async () => importModelEtlJobsRequest ? etlJobsClient.getImportModelEtlJobs(importModelEtlJobsRequest) : new Promise((resolve) => resolve(null)),
  });
};



